import { Navigate, useLocation } from 'react-router-dom'
import { useCurrentUser } from '@/hooks/useAuth'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { data: user, isLoading } = useCurrentUser()
  const location = useLocation()

  // 直接检查 localStorage 作为备用
  const token = localStorage.getItem('tenant_token')

  // 快速放行：有 token 则先放过，避免 me 请求未完成导致的闪回
  if (!user && !token) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return <>{children}</>
}